// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    apiKey: "AIzaSyAbnauOPkoGK0vzp49WVCWPz7NmmQygti8",
    authDomain: "welkom-dev.firebaseapp.com",
    projectId: "welkom-dev",
    storageBucket: "welkom-dev.firebasestorage.app",
    messagingSenderId: "283815736782",
    appId: "1:283815736782:web:0d4def49f45002e3e5279f"
  },
  production: false,
  metaPixelId: '1873680940206132',
  metaPixelConfigs: [
    {
      eventId: '7mVPW3MMI4aL7CqvBB3H',
      formId: '6bXLGn1gMASErYI3gLXK',
      pixelId: '4470776649831505'
    }
  ],
  googlePixelId: 'AW-11490928635',
  googlePixelConversionLabel: 'vxKcCKCq95obEPvPpucq'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
